import React from "react";
import classNames from "classnames";
import { Identifiable, Project } from "@planzone/dto";
import { SelectList } from "@common/selectList";
import { FolderIcon } from "@common/folderIcon";

import { Props } from "./types";
import { ToggleArrow } from "./toggleArrow";
import styles from "./styles.scss";

function ProjectSelection({
  placeholder,
  selectedProjects,
  projects,
  selectProjects,
}: Props) {
  const isProjectSelected = (project: Identifiable<Project>) =>
    !!selectedProjects.find(({ uuid }) => uuid === project.uuid);
  const removeProject = (project: Identifiable<Project>) =>
    selectedProjects.filter(({ uuid }) => uuid !== project.uuid);
  const addProject = (project: Identifiable<Project>) => [
    ...selectedProjects,
    project,
  ];
  const selectProject = (project: Identifiable<Project>) =>
    selectProjects(
      isProjectSelected(project) ? removeProject(project) : addProject(project),
    );

  return (
    <SelectList listClassName={styles.listRoot}>
      {({ isOpen }) => ({
        input: (
          <div
            className={classNames(styles.input, { [styles.opened]: isOpen })}
          >
            <ul className={styles.selectedProjects}>
              {selectedProjects.length > 0 ? (
                selectedProjects.map(({ uuid, name }, index) => (
                  <li key={uuid} className={styles.selectedProject}>
                    <FolderIcon className={styles.folderIcon} />
                    <p className={styles.name}>
                      {name}
                      {index !== selectedProjects.length - 1 ? ", " : ""}
                    </p>
                  </li>
                ))
              ) : (
                <p className={styles.placeholder}>{placeholder}</p>
              )}
            </ul>
            <ToggleArrow className={styles.toggleArrow} />
          </div>
        ),
        list: (
          <ul className={styles.list}>
            {projects.map((project) => (
              <li
                key={project.uuid}
                className={classNames(styles.item, {
                  [styles.selected]: isProjectSelected(project),
                })}
                onClick={() => selectProject(project)}
              >
                <FolderIcon className={styles.folderIcon} />
                <p className={styles.project}>{project.name}</p>
              </li>
            ))}
          </ul>
        ),
      })}
    </SelectList>
  );
}

export { ProjectSelection };
